import { useCallback } from "react";

import type { HotelI18nInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HotelI18nUpdate_HotelInfoSettingsPage_Mutation } from "./mutation";

export const useHotelI18nInfoUpdateMutation = () => {
	const { mutationFunc } = useCustomMutation(HotelI18nUpdate_HotelInfoSettingsPage_Mutation);

	const onUpdate = useCallback(
		async ({ input }: { input: HotelI18nInput }) =>
			await mutationFunc({
				variables: {
					input,
				},
			}),
		[mutationFunc],
	);

	return {
		onUpdate,
	};
};
